"use client";

import { useCallback, useSyncExternalStore } from "react";

/** Bootstrap `md` down — the JS twin of `media-breakpoint-down(md)`. */
export const MD_DOWN_MEDIA_QUERY = "(max-width: 767.98px)";

/**
 * Tracks a CSS media query. Reads false on the server and during hydration, so
 * callers get the desktop layout until the browser answers.
 */
export default function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      const mediaQueryList = window.matchMedia(query);
      mediaQueryList.addEventListener("change", onStoreChange);
      return () => mediaQueryList.removeEventListener("change", onStoreChange);
    },
    [query],
  );
  const getSnapshot = useCallback(() => window.matchMedia(query).matches, [query]);

  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
